// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".send-facebook-container .message-container .facebook-content .facebook-message .facebook-header .member-message-facebook img{max-width:100%}.send-facebook-container .message-container .facebook-content .facebook-message .facebook-images{position:relative}.send-facebook-container .message-container .facebook-content .facebook-message .facebook-images .gallery-image{width:100%}\n", ""]);
// Exports
module.exports = exports;
